import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { Vertical } from '@playbook/models';

export interface VerticalState extends EntityState<Vertical, number> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'vertical' })
export class VerticalStore extends EntityStore<VerticalState, Vertical, number> {
  constructor() {
    super();
  }
}
